// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TheLoader_wrapper_-2k_t","spinner":"TheLoader_spinner_2NIba","spin":"TheLoader_spin_1vfEj","text":"TheLoader_text_1yIUG"};